import type { GridSortDirection } from "@mui/x-data-grid/models/gridSortModel";

export function isSortDirection(value: string | null | undefined): value is GridSortDirection {
  if (value === null || value === undefined) {
    return true;
  }

  return value === "asc" || value === "desc";
}
